document.addEventListener("DOMContentLoaded", function () {
  const orderNowWrapper = document.querySelector(".order-now-wrapper");
  const banner = document.querySelector(".ishislider");

  if (!orderNowWrapper || !banner) return;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
const bannerBottom = banner.offsetTop + banner.offsetHeight;

if (scrollTop >= bannerBottom) {
  orderNowWrapper.classList.add("stick-top");
} else {
  orderNowWrapper.classList.remove("stick-top");
}

  }

  handleScroll(); // Run on load
  window.addEventListener("scroll", handleScroll, { passive: true });
});
document.addEventListener("DOMContentLoaded", function () {

  const sliders = document.querySelectorAll(".ishislideshow-carousel");

  sliders.forEach(function (slider) {

    function playActiveVideo() {
      const activeVideos = slider.querySelectorAll(".owl-item.active video");

      activeVideos.forEach(function (video) {
        video.play().catch(() => {});
      });
    }

    function pauseAllVideos() {
      const videos = slider.querySelectorAll("video");
      videos.forEach(function (video) {
        video.pause();
      });
    }

    // Play first active slide on load
    setTimeout(function () {
      playActiveVideo();
    }, 300);

    // When slide changes
    $(slider).on('changed.owl.carousel', function () {
      pauseAllVideos();
      setTimeout(function () {
        playActiveVideo();
      }, 200);
    });

  });

});
